<template>
  <div>
    <div class="content3 content2" id="content1">
      <div class="row justify-content-center m-lg-5 m-xl-5 mt-5">
        <div class="col-12 col-md-6 col-lg-6 col-xl-6 col-sm-6">
          <h1 class="title-pass-1">
            RESTABLECE TU CONTRASEÑA
          </h1>
          <p class="text-pass">
            Y continúa disfrutando todos los beneficios del MotoClub.
          </p>
        </div>

        <div class="col-12 col-md-7 col-lg-6 col-xl-6 col-sm-6">
          <div class="row justify-content-center">
            <div
              class="col-12 col-12 col-md-10 col-lg-9 col-xl-9 col-sm-12 m-0 p-0 mt-md-2"
            >
              <h5 class="card-title text-login">RECUPERAR CONTRASEÑA</h5>
              <div class="form-group">
                <div class="input-group mb-3">
                  <input
                    :class="{ 'is-danger': errors.pass }"
                    v-model="form.pass"
                    type="password"
                    ref="password"
                    class="form-control color-input-r"
                    aria-label="Email"
                    placeholder="Contraseña nueva"
                    aria-describedby="basic-addon1"
                  />
                  <div @click="showPass(1)" class="eye_pass">
                    <span id="pass1" class="fa-regular fa-eye-slash"></span>
                  </div>
                </div>
                <span
                  v-if="errors.pass"
                  class="text-danger float-left small error-danger"
                  >{{ errors.pass }}</span
                >
              </div>
              <div class="form-group">
                <div class="input-group mb-3">
                  <input
                    :class="{ 'is-danger': errors.pass_confirmation }"
                    v-model="form.pass_confirmation"
                    type="password"
                    ref="confirm_password"
                    class="form-control color-input-r"
                    aria-label="Password"
                    placeholder="Confirmar contraseña nueva"
                    aria-describedby="basic-addon1"
                  />
                  <div @click="showPass(2)" class="eye_pass">
                    <span id="pass2" class="fa-regular fa-eye-slash"></span>
                  </div>
                </div>
                <span
                  v-if="errors.pass_confirmation"
                  class="text-danger float-left small error-danger"
                  >{{ errors.pass_confirmation }}</span
                >
              </div>
            </div>
          </div>
          <div class="col-12 pl-0 pr-0  pl-xl-3 pr-xl-3 pt-2 mt-2 pt-xl-5 mt-xl-4 pt-lg-4 mt-lg-4 pt-md-2 mt-md-2 ">
            <button
              @click="updatePassword()"
              type="button"
              class="btn  btn-sm btn-block btn-danger"
            >
              <span
                v-if="loadingUpdate"
                class="spinner-border spinner-border-sm"
                role="status"
                aria-hidden="true"
              ></span>
              <template v-else>Restablecer</template>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import $ from "jquery";
import axios from 'axios';

export default {
  data() {
    return {
      data: "",
      loadingUpdate: false,
      dataReset: [],
      errors: {
        pass: false,
        pass_confirmation: false
      },
      form: {
        pass: "",
        pass_confirmation: ""
      }
    };
  },
  watch: {
    "form.pass": function(n) {
      if (!n) {
        this.errors.pass = "La contraseña es requerida.";
      } else if (!this.validPassword(n)) {
        this.errors.pass =
          "La contraseña es inválida, debe tener entre 8 a 16 carácteres, al menos un dígito, al menos una minúscula y al menos una mayúscula. Puede tener otros símbolos.";
      } else {
        this.errors.pass = false;
      }
      if (this.form.pass_confirmation == this.form.pass) {
        this.errors.pass_confirmation = false;
      } else {
        this.errors.pass_confirmation = "Las contraseñas deben ser iguales";
      }
    },
    "form.pass_confirmation": function(n) {
      if (this.form.pass_confirmation == this.form.pass) {
        this.errors.pass_confirmation = false;
      } else {
        this.errors.pass_confirmation = "Las contraseñas deben ser iguales";
      }
    }
  },
  methods: {
    updatePassword() {
      var app = this;
      if (this.validateForm()) {
        this.loadingUpdate = true;
        this.form.email = this.dataReset.email;
        this.form.token = this.dataReset.token;
        console.log(this.form.email);
        axios
          .post("api/password/reset", app.form)
          .then(function(res) {
            if (res.data.ResponseCode == 0) {
              app.$swal({
                confirmButtonColor: "#dc3545",
                icon: "success",
                title: "Muy bien",
                text: res.data.ResponseMessage
              });
              app.loadingUpdate = false;
            } else if (res.data.ResponseCode == 1) {
              app.$swal({
                confirmButtonColor: "#dc3545",
                icon: "error",
                title: "Oops...",
                text: res.data.ResponseMessage
              });
            } else {
              app.$swal({
                confirmButtonColor: "#dc3545",
                icon: "error",
                title: "Oops...",
                text: res.data.ResponseMessage
              });
            }
            app.$router.push({ name: "landingPage" });
          })
          .catch(function(error) {
            app.$swal({
              confirmButtonColor: "#dc3545",
              icon: "error",
              title: "Oops...",
              text: "Hubo un error en el sistema, intente nuevamente"
            });
            app.$router.push({ name: "landingPage" });
          });
      }
    },
    validateToken() {
      var app = this;
      var token = this.$route.params.token;
      axios
        .get("api/password/find/" + token)
        .then(function(res) {
          if (res.data.ResponseCode == 0) {
            app.dataReset = res.data.data;
          } else if (res.data.ResponseCode == 1) {
            app.$swal({
              confirmButtonColor: "#dc3545",
              icon: "error",
              title: "Oops...",
              text: res.data.ResponseMessage
            });
          } else {
            app.$swal({
              confirmButtonColor: "#dc3545",
              icon: "error",
              title: "Oops...",
              text: res.data.ResponseMessage
            });
            app.$router.push({ name: "landingPage" });
          }
        })
        .catch(function(error) {
          app.$swal({
            confirmButtonColor: "#dc3545",
            icon: "error",
            title: "Oops...",
            text: res.data.ResponseMessage
          });
        });
    },
    validateForm() {
      if (!this.form.pass) {
        this.errors.pass = "La contraseña es requerida.";
      }

      if (!this.form.pass_confirmation) {
        this.errors.pass_confirmation = "Lacontraseña es requerida.";
      }

      if (this.form.pass_confirmation != this.form.pass) {
        this.errors.pass_confirmation = "Las contraseñas deben ser iguales";
      }

      if (
        !this.errors.pass &&
        !this.errors.pass_confirmation &&
        !this.validPassword(this.errors.pass)
      ) {
        return true;
      }

      return false;
    },
    validPassword(pass) {
      var re = /^(?=\w*\d)(?=\w*[A-Z])(?=\w*[a-z])\S{8,16}$/;
      return re.test(pass);
    },
    showPass(type){
      if(type == 1){
        let pass = this.$refs.password;
        if(pass.type == "password"){
          pass.type = "text";
          $('#pass1').addClass('fa-eye');
          $('#pass1').removeClass('fa-eye-slash');
        } else {
          pass.type = "password";
          $('#pass1').addClass('fa-eye-slash');
          $('#pass1').removeClass('fa-eye');
        }
      } else {
        let pass = this.$refs.confirm_password;
        if(pass.type == "password"){
          pass.type = "text";
          $('#pass2').addClass('fa-eye');
          $('#pass2').removeClass('fa-eye-slash');
        } else {
          pass.type = "password";
          $('#pass2').addClass('fa-eye-slash');
          $('#pass2').removeClass('fa-eye');
        }
      }
    },
  },
  mounted() {
    // this.form = [];
    this.validateToken();
  }
};
</script>

<style>
.content3 {
  height: 550px;
  padding-top: 12%;
  padding-bottom: 1px;
}
#content1 {
  background-size: cover;
  background-image: url("./../../assets/img/resetPassword.jpg");
  background-position: center center;
  background-attachment: fixed;
  background-color: "#171717";
}
.title-pass-1 {
  font-family: "Gotham-UltraItalic", sans-serif;
  font-size: 55px;
  text-align: left;
}
.text-pass {
  font-family: "GothamBookItalic", sans-serif;
  text-align: left;
  font-size: 19px;
}
.color-login {
  background-color: #ffffff00 !important;
  border: solid 0px !important;
}
.color-input-r {
  background-color: #ffffff00 !important;
  height: 30px !important;
  color: #fff !important;
  position: relative;
  padding: 0.375rem 3rem !important;
}
.is-danger {
  border: solid 2px !important;
  border-color: #e9434c !important;
}
.error-danger {
  padding-bottom: 17px !important;
  margin-top: -15px !important;
}
.color-input-r::placeholder {
  color: white !important;
}
.text-login {
  text-align: left !important;
  color: #fff !important;
  font-size: 16px;
  font-weight: bold;
}
.icon::before {
  position: absolute;
  top: 20%;
  left: 5%;
}
/* .fa {
  color: #fff;
} */
.button-login {
  margin-bottom: 5px !important;
  border-radius: 10px !important;
  height: 30px !important;
}
.eye_pass{
  position: absolute;
  height: 100%;
  right: 5%;
  padding-top: 4px;
  cursor: pointer;
  z-index: 1000;
}

/* LAPTOP NORMAL */
@media (max-width: 1200px) {
  .content3 {
    padding-top: 15%;
    padding-bottom: 1px;
    height: 550px;
  }
  .title-pass-1 {
    font-size: 40px;
  }
  .text-pass {
    font-size: 15px;
  }
}

/* TABLET */
@media (max-width: 1023px) {
  .content3 {
    padding-top: 15%;
    padding-bottom: 1px;
    height: 550px;
  }
  .title-pass-1 {
    font-size: 33px;
  }
  .text-pass {
    font-size: 15px;
  }
}

/* MOBILE */
@media (max-width: 767px) {
  .content3 {
    padding-top: 30%;
    padding-bottom: 1px;
    height: 550px;
  }
  .title-pass-1 {
    font-size: 33px;
  }
  .text-pass {
    font-size: 15px;
  }
}

@font-face {
  font-family: "ubuntu-bold";
  src: url("./../../assets/font/Ubuntu-Bold.ttf");
  font-display: swap;
}
@font-face {
  font-family: "Gotham-UltraItalic";
  src: url("./../../assets/font/Gotham-UltraItalic.ttf");
  font-display: swap;
}
@font-face {
  font-family: "GothamBoldItalic";
  src: url("./../../assets/font/GothamBoldItalic.ttf");
  font-display: swap;
}
@font-face {
  font-family: "GothamBookItalic";
  src: url("./../../assets/font/GothamBookItalic.ttf");
  font-display: swap;
}
</style>
